import React, { useEffect, useState } from "react";
import { Switch, Radio } from "components/fields";
import { getUserSettings } from "services/auth/actions";
import { toastAlert } from "@paylixecommerce/shared/components";
import { savePayments } from "../actions";
import { useDispatch } from "react-redux";
import { Formik } from "formik";
import {
	Option,
	ValueContainer,
	SingleValue,
	ArrowIcon,
	SWAPUSDT,
	SWAP,
	Control
} from "./config";
import config from "constants/config";
import { useForceUpdate } from "components/hooks";
import useMobile from "../../../../../../../hooks/useMobile";
import { Select } from "@paylixecommerce/shared/components";
import HowTo from "./how-to";


import "./index.scss";

export const CollapseArrow = () => <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M1 1.5L6 6.5L11 1.5" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>


const Swaps = ({ formRef }) => {

	const [progress, setProgress] = useState(0);
	const [type, setType] = useState(0);
	const [initialType, setInitialType] = useState(0);
	const [isHelpOpen, setHelp] = useState(false);
	let isMobile = useMobile();
	const [swap, setSwap] = useState({
		"BITCOIN": "USDT:TRC20",
		"ETHEREUM": "USDT:TRC20",
		"USDT:TRC20": "USDT:TRC20",
		"USDT:ERC20": "USDT:TRC20",
		"USDT:BEP20": "USDT:TRC20",
		"USDT:MATIC": "USDT:TRC20",

		"USDC:ERC20": "USDT:TRC20",
		"USDC:BEP20": "USDT:TRC20",
		// "USDC:MATIC": "USDT:TRC20", // Removed - USDC.e Bridged not supported
		"USDC_NATIVE:MATIC": "USDT:TRC20",

		"SHIB:BEP20": "USDT:TRC20",
		"SHIB:ERC20": "USDT:TRC20",
		// "SHIB:MATIC": "USDT:TRC20",

		"DAI:BEP20": "USDT:TRC20",
		"DAI:ERC20": "USDT:TRC20",
		"DAI:MATIC": "USDT:TRC20",

		// "WETH:ERC20": "USDT:TRC20", // Wrapped ETH disabled - not supported by current provider
		// "WETH:MATIC": "USDT:TRC20",

		// "PEPE:ERC20": "USDT:TRC20", // PEPE token disabled until API support confirmation

		// "APE:ERC20": "USDT:TRC20", // ApeCoin temporarily disabled - payment gateway limitations

		"LITECOIN": "USDT:TRC20",
		"POLYGON": "USDT:TRC20",
		"BITCOIN_CASH": "USDT:TRC20",
		"MONERO": "USDT:TRC20",
		"SOLANA": "USDT:TRC20",
		"TRON": "USDT:TRC20",
		// "NANO": "USDT:TRC20", // Disabled - API provider no longer supports
		// "CONCORDIUM": "USDT:TRC20", // Removed - not supported by current provider
		// "RIPPLE": "USDT:TRC20", // Ripple disabled - not supported by current provider
		// "CRONOS": "USDT:TRC20", // Temporarily removed due to API compatibility issues
		"BINANCE_COIN": "USDT:TRC20",
		// "BINANCE": "USDT:TRC20", // Binance Pay temporarily disabled - payment gateway limitations
	});
	const [initialSwap, setInitialSwap] = useState({
		"BITCOIN": "USDT:TRC20",
		"ETHEREUM": "USDT:TRC20",

		"USDT:TRC20": "USDT:TRC20",
		"USDT:ERC20": "USDT:TRC20",
		"USDT:BEP20": "USDT:TRC20",
		"USDT:MATIC": "USDT:TRC20",

		"USDC:ERC20": "USDT:TRC20",
		"USDC:BEP20": "USDT:TRC20",
		// "USDC:MATIC": "USDT:TRC20", // Removed - USDC.e Bridged not supported
		"USDC_NATIVE:MATIC": "USDT:TRC20",

		"SHIB:BEP20": "USDT:TRC20",
		"SHIB:ERC20": "USDT:TRC20",
		// "SHIB:MATIC": "USDT:TRC20",

		"DAI:BEP20": "USDT:TRC20",
		"DAI:ERC20": "USDT:TRC20",
		"DAI:MATIC": "USDT:TRC20",

		// "WETH:ERC20": "USDT:TRC20", // Wrapped ETH disabled - not supported by current provider
		// "WETH:MATIC": "USDT:TRC20",

		// "PEPE:ERC20": "USDT:TRC20", // PEPE token disabled until API support confirmation

		// "APE:ERC20": "USDT:TRC20", // ApeCoin temporarily disabled - payment gateway limitations

		"LITECOIN": "USDT:TRC20",
		"POLYGON": "USDT:TRC20",
		"BITCOIN_CASH": "USDT:TRC20",
		"MONERO": "USDT:TRC20",
		"SOLANA": "USDT:TRC20",
		"TRON": "USDT:TRC20",
		// "NANO": "USDT:TRC20", // Disabled - API provider no longer supports
		// "CONCORDIUM": "USDT:TRC20", // Removed - not supported by current provider
		// "RIPPLE": "USDT:TRC20", // Ripple disabled - not supported by current provider
		// "CRONOS": "USDT:TRC20", // Temporarily removed due to API compatibility issues
		"BINANCE_COIN": "USDT:TRC20",
		// "BINANCE": "USDT:TRC20", // Binance Pay temporarily disabled - payment gateway limitations
	});
	const [initialValues, setInitialValues] = useState({ });

	let dispatch = useDispatch();
	const forceUpdate = useForceUpdate();

	let onSubmit = (values, { resetForm }) => {

		dispatch(savePayments({
			crypto_conversion: values.crypto_conversion ? true : false,
			crypto_conversion_config: JSON.stringify({
				conversion_mode: type,
				config: swap,
			}),
		}, {
			onUploadProgress: progressEvent => {
				setProgress((progressEvent.loaded / progressEvent.total) * 100);
			}
		}))
			.then(res => {
				toastAlert('success', res.message);
				resetForm({ values });
				setInitialSwap(swap);
				getSettings();
			})
			.catch(res => toastAlert('error', res.error))
			.finally(() => {
				setProgress(0);
			})
	}

	const getSettings = () => {
		dispatch(getUserSettings())
			.then(({ data }) => {

				let { crypto_conversion, crypto_conversion_config } = data.settings.shop;

				setType(crypto_conversion_config.conversion_mode);
				setInitialType(crypto_conversion_config.conversion_mode);

				if(crypto_conversion_config && crypto_conversion_config.config) {
					setSwap(crypto_conversion_config.config);
					setInitialSwap(crypto_conversion_config.config);
				}

				setInitialValues({ crypto_conversion });
			})
	};

	useEffect(() => {
		getSettings();
	}, []);

	let isCustom = type === "CUSTOM";

	let submitButton = document && document.getElementById && document.getElementById('submit-settings');

	return <Formik initialValues={initialValues} innerRef={formRef} onSubmit={onSubmit} enableReinitialize={true}>

		{form => {

			const isDataChanged = form.dirty || JSON.stringify(swap) !== JSON.stringify(initialSwap) || (type !== initialType);

			if(submitButton) {
				submitButton.classList.remove(isDataChanged ? 'd-none' : 'd-flex');
				submitButton.classList.add(isDataChanged ? 'd-flex' : 'd-none');
			}

			return <>
				<div className="product-progress" style={{ width: `${progress}%`}} />

				<form onSubmit={form.handleSubmit}>

					<HowTo />

					<div className="settings-content mb-4">
						<div className="settings-content-title">Payout Swap</div>

						<Switch
							name="crypto_conversion"
							label="Enabled"
							{...form}
							left
							note="If enabled, we will automatically swap your eligible cryptocurrency payouts into either USDT or your preferred crypto of choice. Crypto swaps are done in a completely non-custodial way, we will not place hands on your money in any way. Applied fees are 0.4% for the swap + network fees to send the transaction; network fees are reduced thanks to our payout system."
						/>
					</div>

					<div className={`settings-content ${form.values.crypto_conversion ? '' : 'd-none'}`}>
						<div className="settings-content-title">Conversion Type</div>

						<div className="swap-switch">
							<Radio
								label="Standard"
								labelPosition="right"
								name="conversion_mode"
								value="STANDARD"
								onChange={(e) => {
									setType(e.target.value);
								}}
								checked={!isCustom}
							/>
							<Radio
								label="Custom"
								labelPosition="right"
								name="conversion_mode"
								value="CUSTOM"
								onChange={(e) => {
									setType(e.target.value)
								}}
								checked={isCustom}
							/>
						</div>

						<div className="swap-message">
							Choose your preferred way of swapping cryptos. In the Standard mode, all your cryptos will be swapped to USDT, with priority given to TRC20, BEP20, ERC20 and MATIC, in that order.
							When selecting the Custom mode, you're able to define your preferred crypto for each pair to get paid out with.
						</div>

						{(isCustom ? [...SWAP] : [{ label: "All", value: "All" }]).map(({ label, value }, key) => (
							<div className="swap-container" key={key}>
								<div className="swap-item">
									<div className="swap-item-from">
										<div>Swap From</div>
										{
											isCustom ?
												<div className="swap-item-img value">
													<div className="position-relative">
														<img src={config.PAYMENT_ICONS[value]} alt=""/>
														{value === "USDT:ERC20" ? <img className="swap-item-img-chain" src={config.PAYMENT_ICONS["ETHEREUM"]} alt=""/> : null}
														{value === "USDT:TRC20" ? <img className="swap-item-img-chain" src={config.PAYMENT_ICONS["TRON"]} alt=""/> : null}
														{value === "USDT:BEP20" ? <img className="swap-item-img-chain" src={config.PAYMENT_ICONS["BINANCE_COIN"]} alt=""/> : null}
														{value === "USDT:MATIC" ? <img className="swap-item-img-chain" src={config.PAYMENT_ICONS["POLYGON"]} alt=""/> : null}

														{value === "USDC:ERC20" ? <img className="swap-item-img-chain" src={config.PAYMENT_ICONS["ETHEREUM"]} alt=""/> : null}
														{value === "USDC:BEP20" ? <img className="swap-item-img-chain" src={config.PAYMENT_ICONS["BINANCE_COIN"]} alt=""/> : null}
														{/*{value === "USDC:MATIC" ? <img className="swap-item-img-chain" src={config.PAYMENT_ICONS["POLYGON"]} alt=""/> : null}*/}
														{value === "USDC_NATIVE:MATIC" ? <img className="swap-item-img-chain" src={config.PAYMENT_ICONS["POLYGON"]} alt=""/> : null}

														{value === "DAI:ERC20" ? <img className="swap-item-img-chain" src={config.PAYMENT_ICONS["ETHEREUM"]} alt=""/> : null}
														{value === "DAI:BEP20" ? <img className="swap-item-img-chain" src={config.PAYMENT_ICONS["BINANCE_COIN"]} alt=""/> : null}
														{value === "DAI:MATIC" ? <img className="swap-item-img-chain" src={config.PAYMENT_ICONS["POLYGON"]} alt=""/> : null}

														{value === "SHIB:ERC20" ? <img className="swap-item-img-chain" src={config.PAYMENT_ICONS["ETHEREUM"]} alt=""/> : null}
														{value === "SHIB:BEP20" ? <img className="swap-item-img-chain" src={config.PAYMENT_ICONS["BINANCE_COIN"]} alt=""/> : null}
														{/*{value === "SHIB:MATIC" ? <img className="swap-item-img-chain" src={config.PAYMENT_ICONS["POLYGON"]} alt=""/> : null}*/}

														{/*{value === "WETH:ERC20" ? <img className="swap-item-img-chain" src={config.PAYMENT_ICONS["ETHEREUM"]} alt=""/> : null}*/}
														{/*{value === "WETH:MATIC" ? <img className="swap-item-img-chain" src={config.PAYMENT_ICONS["POLYGON"]} alt=""/> : null}*/}

														{/*{value === "PEPE:ERC20" ? <img className="swap-item-img-chain" src={config.PAYMENT_ICONS["ETHEREUM"]} alt=""/> : null}*/}

														{/*{value === "APE:ERC20" ? <img className="swap-item-img-chain" src={config.PAYMENT_ICONS["ETHEREUM"]} alt=""/> : null}*/}
													</div>
													{config.PAYMENT_FULL_NAME[value]}
												</div>
												:
												<div className="swap-item-img value">
													{[
														"BITCOIN",
														"ETHEREUM",
														"USDC",
														"USDT",
														"LITECOIN",
														"POLYGON",
														"BITCOIN_CASH",
														"BINANCE_COIN",
														"MONERO",
														"SOLANA",
														"TRON",
														"DAI",
														"SHIB",
														// "APE", // ApeCoin temporarily disabled - payment gateway limitations
														// "PEPE", // PEPE token disabled until API support confirmation
														// "WETH", // Wrapped ETH disabled - not supported by current provider
														// "NANO", // Disabled - API provider no longer supports
														// "CONCORDIUM", // Removed - not supported by current provider
														// "RIPPLE", // Ripple disabled - not supported by current provider
														// "CRONOS" // Temporarily removed due to API compatibility issues
													]
														.map((g, key) => <img key={key} className={key === 0 ? "ml-0" : ""} src={config.PAYMENT_ICONS[g]} alt=""/>)}
												</div>
										}
									</div>
									<div className="swap-item-arrow" >
										<ArrowIcon />
									</div>

									<div className="swap-item-to">
										<div>Swap To</div>

										<Select
											placeholder="Select crypto"
											options={isCustom ? SWAP : SWAPUSDT}
											isMulti={false}
											isSearchable={false}
											menuPlacement="auto"
											classNameDropdown="swap-select-dropdown"
											name="crypto"
											value={isCustom ?
												(swap[value] && typeof swap[value] === 'string' ? SWAP.find((gateway) => swap[value] === gateway.value) : swap[value])
												:
												(swap["USDT:TRC20"] && typeof swap["USDT:TRC20"] === 'string' ? SWAP.find((gateway) => swap["USDT:TRC20"] === gateway.value) : swap["USDT:TRC20"])
										}
											onChange={(option) => {
												if(isCustom) {
													let data = {
														...swap,
														[value]: option.value
													};
													setSwap(data);
													forceUpdate();
												} else {
													let data = {};
													Object.keys(swap).map(g => data[g] = option.value)
													setSwap(data);
													forceUpdate();
												}
												forceUpdate();
											}}
											components={{
												SingleValue,
												Option,
												ValueContainer,
												Control,
												DropdownIndicator: () => null,
												IndicatorsContainer: () => null,
												Input: ({ children }) => <div className="d-none">{children}</div>
											}}
										/>
									</div>
								</div>
							</div>
						))}

					</div>
				</form>

			</>
		}}

	</Formik>
}

export default Swaps;
